const getUpdatedFilterForCategory = (
  categoryKey: string,
  latestValuesFromState: { filterKey: string; categoryKey: string }[]
) => {
  const newValues = `${categoryKey}:${latestValuesFromState
    .filter((cat) => cat.categoryKey === categoryKey)
    .map((item) => item.filterKey)
    .join(",")}`;
  return newValues;
};

const prepareFiltersForApiCall = (
  queryStringToUpdate: string, // bq, q, sort
  filtersToAdd: { filterKey: string; categoryKey: string }[],
  additionalFilters
): URL => {
  const pageUrl = new URL(window.location.href);

  //scenario: all filters need to be removed
  if (filtersToAdd?.length === 0) {
    pageUrl.searchParams.delete("bq");
    return pageUrl;
  }

  let newPageUrl = pageUrl;
  const filterToUpdate = additionalFilters.bq !== ""; // all values from bq filter
  const filtersToAddUnderBq = filtersToAdd.map((item) => item);

  // scenario: some filters already exist in the URL and they need updating
  if (filterToUpdate) {
    const distinctCategories = Array.from(
      new Set(filtersToAddUnderBq.map((x) => x.categoryKey))
    );

    const aux = distinctCategories.map((categoryname) => {
      const newFilterValues = getUpdatedFilterForCategory(
        categoryname,
        filtersToAddUnderBq
      );

      return newFilterValues;
    });
    const newBq = aux.join("|");
    newPageUrl.searchParams.set(queryStringToUpdate, newBq);
    return newPageUrl;
  }

  if (filtersToAddUnderBq?.length > 0) {
    pageUrl.searchParams.set(
      queryStringToUpdate,
      `${filtersToAddUnderBq[0].categoryKey}:${filtersToAddUnderBq
        .map((item) => item.filterKey)
        .join(",")}`
    );
  }

  return pageUrl;
};

export default prepareFiltersForApiCall;
